// ── Service de Vendas (núcleo/aplicação) ──────────────────────────
// Registro de venda + regra de "mover card ganho para a última etapa".
// Recebe o repositório via porta (DI); não conhece Supabase.

import type { ISalesRepository, RegisterCardSaleParams, SaleRpcResult } from '../ports/ISalesRepository';

export class SalesService {
  constructor(private readonly repo: ISalesRepository) {}

  registerCardSaleFromProposal = (params: RegisterCardSaleParams): Promise<SaleRpcResult> =>
    this.repo.registerCardSaleFromProposal(params);

  // Move o card para a etapa final (maior order_index) do pipeline. Não-fatal:
  // a venda já está gravada; falha aqui só não reposiciona o card no Kanban.
  moveWonCardToLastStage = async (cardId: string | null | undefined): Promise<void> => {
    if (!cardId) return;
    const card = await this.repo.getCardPipelineStage(cardId);
    if (!card?.pipeline_id) return;
    const lastStageId = await this.repo.getLastActiveStageId(card.pipeline_id);
    if (lastStageId && lastStageId !== card.stage_id) {
      await this.repo.updateCardStage(cardId, lastStageId);
    }
  };
}
